var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.6666667px",
    height: "18.5px",
    viewBox: "0 0 16.6666667 18.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres---Cat\\xE9gories",
    transform: "translate(-1432.666667, -333.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(40.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1390.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 22 0 22 22 0 22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.66666667,
    y1: 6.41666667,
    x2: 18.3333333,
    y2: 6.41666667,
    id: "Path",
    stroke: "#D93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.16666667,
    y1: 10.0833333,
    x2: 9.16666667,
    y2: 15.5833333,
    id: "Path",
    stroke: "#D93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8333333,
    y1: 10.0833333,
    x2: 12.8333333,
    y2: 15.5833333,
    id: "Path",
    stroke: "#D93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333333,6.41666667 L5.5,17.4166667 C5.5,18.4291887 6.32081129,19.25 7.33333333,19.25 L14.6666667,19.25 C15.6791887,19.25 16.5,18.4291887 16.5,17.4166667 L17.4166667,6.41666667",
    id: "Path",
    stroke: "#D93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,6.41666667 L8.25,3.66666667 C8.25,3.16040565 8.66040565,2.75 9.16666667,2.75 L12.8333333,2.75 C13.3395944,2.75 13.75,3.16040565 13.75,3.66666667 L13.75,6.41666667",
    id: "Path",
    stroke: "#D93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteColor);
export default __webpack_public_path__ + "static/media/icon_delete_color.0d004e47d4b0b6f76abb404e1477873e.svg";
export { ForwardRef as ReactComponent };